import { useReducer, useEffect } from 'react';

// Components
import { Box } from '@mui/material';
import { Route, Switch } from 'react-router-dom';
import EventAppBar from 'components/navigation/EventAppBar';
import EventDrawer from 'components/navigation/EventDrawer';
import EventTabs from 'components/navigation/EventTabs';

// Pages
import EventDashboard from 'pages/event/EventDashboard';
import EventDetails from 'pages/event/EventDetails';
import Orders from 'pages/Orders';
import OnsiteOrders from 'pages/event/OnsiteOrders';
import Products from 'pages/event/products/Products';
import Discounts from 'pages/Discounts';
import Checkout from 'pages/event/Checkout';
import CheckoutQuestions from 'pages/event/registration/Registration';
import Publish from 'pages/event/Publish';
import Payouts from 'pages/event/salesSummary/SalesSummary';
import Downloads from 'pages/event/Downloads';
import Reports from 'pages/event/reports/Reports';
import Promote from 'pages/event/promote/Promote';
import OnsiteRoles from 'pages/event/onsiteRoles/OnsiteRoles';
import fetchExpresso from 'utility/fetchExpresso';

// Other
import { EventContext, EventDispatchContext } from 'context/event';
import PageNotFound from 'pages/PageNotFound';

const defaultState = {};

function reducer(state, action) {
    switch (action.type) {
        case 'set_event':
            return { ...state, ...action.event };

        default:
            throw new Error();
    }
}

export default function EventNavigator(props) {
    const path = props.match.path;
    const eventId = props.match.params.id;

    const [event, dispatch] = useReducer(reducer, defaultState);

    const eventLoaded = event !== defaultState;

    useEffect(() => {
        fetchExpresso(`/apiv2/events/${eventId}`)
            .then(async (res) => {
                if (res.status === 200) {
                    const data = await res.json();
                    dispatch({
                        type: 'set_event',
                        event: { ...data },
                    });
                }
            })
            .catch((e) => null);
    }, [eventId]);

    return (
        <EventContext.Provider value={event}>
            <EventDispatchContext.Provider value={dispatch}>
                <Box display="flex" flexDirection={'column'} width="100%" height="100%">
                    <EventAppBar />

                    <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                        <EventTabs />
                    </Box>

                    <Box display="flex" flexGrow={1} minHeight={0}>
                        <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
                            <EventDrawer />
                        </Box>

                        {eventLoaded && (
                            <Box flexGrow={1} maxWidth={'100%'} minWidth={0} minHeight={0}>
                                <Switch>
                                    <Route exact path={`${path}/`} component={EventDashboard} />
                                    <Route
                                        exact
                                        path={`${path}/details`}
                                        component={EventDetails}
                                    />
                                    <Route exact path={`${path}/checkout`} component={Checkout} />
                                    <Route
                                        exact
                                        path={`${path}/checkout-form`}
                                        component={CheckoutQuestions}
                                    />
                                    <Route exact path={`${path}/orders`} component={Orders} />
                                    <Route exact path={`${path}/onsite`} component={OnsiteOrders} />
                                    <Route exact path={`${path}/tickets`} component={Products} />
                                    <Route exact path={`${path}/discounts`} component={Discounts} />
                                    <Route exact path={`${path}/payouts`} component={Payouts} />
                                    <Route exact path={`${path}/publish`} component={Publish} />
                                    <Route exact path={`${path}/downloads`} component={Downloads} />
                                    <Route exact path={`${path}/reports`} component={Reports} />
                                    <Route exact path={`${path}/promote`} component={Promote} />
                                    {process.env.REACT_APP_ENV === 'development' && (
                                        <Route
                                            exact
                                            path={`${path}/onsite-roles`}
                                            component={OnsiteRoles}
                                        />
                                    )}

                                    <Route path="*" component={PageNotFound} />
                                </Switch>
                            </Box>
                        )}
                    </Box>
                </Box>
            </EventDispatchContext.Provider>
        </EventContext.Provider>
    );
}
